import isEmpty from 'lodash/isEmpty';
import type { AudienceForm, GroupLike } from '../types';

const hasSegmentDataInGroup = (group: GroupLike): boolean => {
  if ('groups' in group) {
    return group.groups.some(hasSegmentDataInGroup);
  }

  return (
    !isEmpty(group.direct?.segments) ||
    !isEmpty(group.predefined?.segments) ||
    !isEmpty(group.lookalike?.segments) ||
    !isEmpty(group.demographic_age?.segments) ||
    !isEmpty(group.demographic_gender?.segments) ||
    !isEmpty(group.location?.segments)
  );
};

export const hasSegmentDataInIncludes = (
  normalizedDefinition: AudienceForm['normalized_definition'] | undefined
): boolean => {
  const groups = normalizedDefinition?.includes?.groups ?? [];

  return groups.some(hasSegmentDataInGroup);
};
